module.exports = __webpack_public_path__ + "static/img/anc_switch.7f421f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aircolor/anc_switch.png
// module id = DbvV
// module chunks = 1